import axios from 'axios';
/**
 * Get the current VAT mode
 * @returns Currently selected VAT mode (ex or inc)
 */
export function getVatMode() {
    const vatMode = document.querySelector('body');
    return vatMode?.getAttribute('data-vat-mode') == 'inc VAT' ? 'inc' : 'ex';
}
/**
 * Check if the user is an administrator
 * @returns Whether the current user is logged in (admin)
 */
export async function isAdmin() {
    const { data } = await axios.get('/api/user/isLoggedIn');
    return data.isLoggedIn;
}
export function JsonToList(json, vue) {
    const vnodes = [];
    for (const key in json) {
        const children = [];
        const capitalized = key.charAt(0).toUpperCase()
            + key.slice(1);
        if (typeof json[key] == 'object') {
            children.push(`${capitalized}:`);
            children.push(JsonToList(json[key], vue));
        }
        else if (typeof json[key] === 'string') {
            if (key == 'message') {
                children.push(vue.$createElement('strong', json[key]));
            }
            else {
                children.push(`${capitalized}: ${json[key]}`);
            }
        }
        vnodes.push(vue.$createElement('li', children));
    }
    return vue.$createElement('ul', vnodes);
}
